import { Matrix } from "ml-matrix";

import deliveryAreaImageA from "../../../assets/twoview/two_view_training/delivery_area_1l/im0.png";
import deliveryAreaImageB from "../../../assets/twoview/two_view_training/delivery_area_1l/im1.png";
import deliveryAreaCalibration from "../../../assets/twoview/two_view_training/delivery_area_1l/calib.txt";

import playgroundImageA from "../../../assets/twoview/two_view_training/playground_1l/im0.png";
import playgroundImageB from "../../../assets/twoview/two_view_training/playground_1l/im1.png";
import playgroundCalibration from "../../../assets/twoview/two_view_training/playground_1l/calib.txt";

import forestImageA from "../../../assets/twoview/two_view_training/forest_1s/im0.png";
import forestImageB from "../../../assets/twoview/two_view_training/forest_1s/im1.png";
import forestCalibration from "../../../assets/twoview/two_view_training/forest_1s/calib.txt";

export const ETH3D_SCENES = [
  {
    id: "delivery_area_1l",
    name: "Delivery Area",
    imageA: deliveryAreaImageA,
    imageB: deliveryAreaImageB,
    calibrationUrl: deliveryAreaCalibration,
  },
  {
    id: "playground_1l",
    name: "Playground",
    imageA: playgroundImageA,
    imageB: playgroundImageB,
    calibrationUrl: playgroundCalibration,
  },
  {
    id: "forest_1s",
    name: "Forest",
    imageA: forestImageA,
    imageB: forestImageB,
    calibrationUrl: forestCalibration,
  },
];

export async function loadETH3DScene(sceneId) {
  const scene = ETH3D_SCENES.find((candidate) => candidate.id === sceneId);

  if (!scene) {
    throw new Error(`Unknown ETH3D scene: ${sceneId}`);
  }

  const response = await fetch(scene.calibrationUrl);

  if (!response.ok) {
    throw new Error(
      `Failed to load ETH3D calibration for ${scene.name}: ${response.status}`,
    );
  }

  const calibrationText = await response.text();
  const calibration = parseETH3DCalibration(calibrationText);

  return {
    ...scene,
    calibration,
  };
}

export function parseETH3DCalibration(text) {
  const values = {};

  for (const rawLine of text.split(/\r?\n/)) {
    const line = rawLine.trim();

    if (!line) {
      continue;
    }

    const separator = line.indexOf("=");

    if (separator === -1) {
      continue;
    }

    const key = line.slice(0, separator).trim();
    const value = line.slice(separator + 1).trim();

    values[key] = value;
  }

  if (!values.cam0 || !values.cam1) {
    throw new Error("ETH3D calibration is missing cam0 or cam1.");
  }

  const cameraMatrixA = parseMatrix(values.cam0);
  const cameraMatrixB = parseMatrix(values.cam1);
  const baseline = parseRequiredNumber(values.baseline, "baseline");
  const width = parseRequiredNumber(values.width, "width");
  const height = parseRequiredNumber(values.height, "height");
  const disparityOffset =
    values.doffs !== undefined ? Number(values.doffs) : null;
  const disparityCount =
    values.ndisp !== undefined ? Number(values.ndisp) : null;

  return {
    cameraMatrixA,
    cameraMatrixB,
    baseline,
    width,
    height,
    disparityOffset,
    disparityCount,
  };
}

function parseMatrix(value) {
  const trimmed = value.trim();

  if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) {
    throw new Error(`Invalid ETH3D camera matrix: ${value}`);
  }

  const rows = trimmed
    .slice(1, -1)
    .split(";")
    .map((row) => row.trim().split(/\s+/).map(Number));

  if (
    rows.length !== 3 ||
    rows.some(
      (row) =>
        row.length !== 3 || row.some((number) => !Number.isFinite(number)),
    )
  ) {
    throw new Error(`Invalid ETH3D camera matrix: ${value}`);
  }

  return new Matrix(rows);
}

function parseRequiredNumber(value, name) {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    throw new Error(`Invalid or missing ETH3D calibration value: ${name}`);
  }

  return number;
}
